import { Required } from '@decorators/entity-required.decorator';
import { Primary } from '@decorators/entity-primary.decorator';
import { Phrase } from './phrase.class';
import { PhraseCategory } from './phrase-category.class';
import { Dommage } from './dommage.class';

export class PhraseVersion {
	@Required
	@Primary
	id: number;

	@Required
	version: number;

	@Required
	isActive: boolean;
	
	phrases?: Phrase[];
	categories?: PhraseCategory[];
	dommages?: Dommage[];
	noColorOptions?: string[];
	colorOptions?: string[];
	optionsPreco?: [];
}

